import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getPostBySlug } from "../lib/data";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "@/hooks/use-page-meta";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  usePageMeta({ title: post?.title, description: post?.excerpt, image: post?.image_url });

  useEffect(() => {
    getPostBySlug(slug).then((p) => {
      setPost(p);
      setLoading(false);
    });
  }, [slug]);

  if (loading) {
    return (
      <div className="py-32 px-6 text-center text-[#6B6B6B] font-mono-lbl text-sm" data-testid="post-loading">
        Yazı yükleniyor...
      </div>
    );
  }

  if (!post) {
    return (
      <div className="py-32 px-6 text-center" data-testid="post-not-found">
        <h1 className="text-2xl font-serif-display text-[#404040]">Yazı bulunamadı</h1>
        <Link to="/blog" className="text-[#8F7648] text-sm mt-4 inline-block hover:text-[#8F7648] transition-colors">
          Tüm yazılara dön
        </Link>
      </div>
    );
  }

  return (
    <div className="py-16 px-6" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/blog"
          data-testid="post-back-link"
          className="inline-flex items-center gap-2 text-xs font-mono-lbl uppercase tracking-widest text-[#6B6B6B] hover:text-[#B09060] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Tüm Yazılar
        </Link>

        <Reveal>
          <div className="mt-8">
            <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#8F7648]">
              {new Date(post.created_at).toLocaleDateString("tr-TR", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </div>
            <h1 className="text-3xl md:text-5xl font-serif-display text-[#404040] mt-3 leading-tight" data-testid="post-title">
              {post.title}
            </h1>
          </div>

          {post.image_url && (
            <div className="rounded-sm overflow-hidden border border-[#B09060]/20 mt-8 h-72 md:h-96">
              <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
            </div>
          )}

          <article className="mt-10 space-y-6 text-[#555555] text-sm md:text-base leading-relaxed" data-testid="post-content">
            {(post.content || "").split("\n\n").map((para, i) => (
              <p key={i} className="whitespace-pre-line">{para}</p>
            ))}
          </article>

          <div className="mt-14 rounded-sm border border-[#B09060]/30 bg-[#F2F3EB] p-8 text-center">
            <h3 className="text-xl font-serif-display text-[#404040]">
              Kurumsal filonuz için teklif alın
            </h3>
            <p className="text-xs text-[#6B6B6B] mt-2">
              2026 model sıfır km filomuz hakkında size özel teklif hazırlayalım.
            </p>
            <Link
              to="/iletisim"
              data-testid="post-quote-cta"
              className="inline-block mt-5 px-8 py-3.5 bg-[#B09060] text-[#FAFBF6] font-bold text-xs uppercase tracking-wider rounded hover:bg-[#8F7648] transition-colors"
            >
              Hızlı Teklif Al
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
